import Header from './Components/Header';
import Footer from './Components/Footer';
import Contenido from './Components/contenido';
import './App.css';

function App() {
  return (
    <div className="App">
      <>
      <Header/>
      <Contenido/>
      <Footer/>
      </>
    </div>
  );
}

export default App;
